import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  ActivateIndividualRequest,
  Individual,
  individualsService,
} from '@aslanpay/portal-common-lib';

const useActivateIndividual = ({
  onSuccess,
  onError,
}: UseMutationOptions<Individual, Error, ActivateIndividualRequest>) => {
  return useMutation<Individual, Error, ActivateIndividualRequest>(
    ({ id, phoneNumber, referralCode }: ActivateIndividualRequest) =>
      individualsService.activateIndividual({ id, phoneNumber, referralCode }),
    { onSuccess, onError }
  );
};

export default useActivateIndividual;
